import {ChangeEventHandler, useCallback, useState} from 'react';
import {FormEventHandler} from 'react';
import {useMutation} from 'react-query';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import {
  NewsletterSubscribeErrorResponseType,
  subscribeToNewsletter,
} from '../backendApi/newsletterApi';
import 'sweetalert2/dist/sweetalert2.min.css';
import {AxiosError} from 'axios';

const defaultErrorMessage =
  'We could not subscribe you at this time. Please try again later.';

const SwalComponent = withReactContent(Swal);

function getErrorText(data) {
  return data?.errors?.email ?? defaultErrorMessage;
}

export default function NewsletterSignup() {
  const [email, setEmail] = useState('');

  const {mutate: subscribe, isLoading} = useMutation(subscribeToNewsletter, {
    onSuccess: () => {
      setEmail('');
      SwalComponent.fire({
        title: 'Subscribed!',
        html: 'Thank you for subscribing to our newsletter!',
        icon: 'success',
        showClass: {
          popup: 'animate__animated animate__fadeInUp',
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp',
        },
        customClass: {
          title: 'title-3',
          actions: 'buttons-container',
          confirmButton: ' twl-button button button_size_large',
        },
      });
    },
    onError: (error: AxiosError<NewsletterSubscribeErrorResponseType>) => {
      SwalComponent.fire({
        title: 'Oops!',
        html: getErrorText(error.response.data),
        icon: 'error',
        showClass: {
          popup: 'animate__animated animate__fadeInUp',
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp',
        },
        customClass: {
          title: 'title-3',
          actions: 'buttons-container',
          confirmButton: ' twl-button button button_size_large',
        },
      });
    },
  });

  const emailChangeHandler: ChangeEventHandler<HTMLInputElement> = useCallback(
    (event) => setEmail(event.target.value),
    [],
  );

  const submitHandler: FormEventHandler<HTMLFormElement> = useCallback(
    (event) => {
      event.preventDefault();
      subscribe({email});
    },
    [email, subscribe],
  );

  return (
    <div id="newsletter-signup" className="main-footer__seorow-newsletter">
      <div className="main-footer__seorow-newsletter__wrap">
        <h6 className="main-footer__seorow-newsletter__title">
          Subscribe to our newsletter <br /> to stay informed.
        </h6>
        <form onSubmit={submitHandler}>
          <div className="main-footer__seorow-newsletter__form">
            <input
              type="email"
              className="main-footer__seorow-newsletter__email"
              placeholder="Enter your email"
              autoComplete="off"
              value={email}
              onChange={emailChangeHandler}
              required
            />
            <button
              type="submit"
              className="main-footer__seorow-newsletter__button button button_size_small"
              disabled={isLoading}
            >
              Send
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
